import * as React from 'react';
import { reduxForm, InjectedFormProps, Field, getFormSyncErrors } from 'redux-form';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
import { createArticleTag } from 'redux/modules/magazine/article/managearticletag';
import {
	IManageArticleTag,
	IManageArticleTagAction,
	IArticleTagManageDomainValue,
} from 'models/magazine/article/managearticletag';
import { ILanguage } from 'models/common';
import { IModalAction } from 'models/modal';
import * as c from 'models/constants';
import { Modal, LoadingOverlayWrapper, Button, ErrorSummary } from 'components';
import { PortalSelectMenu, PortalInputField } from 'components/FormControls';
import { required, nonWhitespace } from 'helpers/validationattributes';
import { PortalPageSection, ButtonsSection } from 'components/PortalStructure';
import { onCloseModalForm } from 'helpers/common';
require('./style.css');

interface IProps extends InjectedFormProps {
	initialValues: IArticleTagManageDomainValue;
	manageArticleTag: IManageArticleTag;
	location: any;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	submitFailed: boolean;
	formErrors?: any;

	/* function props */
	handleSubmit: any;
	languageDomainValues: ILanguage;
	showHeaderCloseButton?: boolean;
	t?: (key: string) => string;
	closeModal?: () => IModalAction;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	createArticleTag: (articleTag: IArticleTagManageDomainValue) => IManageArticleTagAction;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class EditArticleTagForm extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.mapErrorKeyToMessage = this.mapErrorKeyToMessage.bind(this);
	}

	public componentDidUpdate(prevProps: IProps) {
		if (
			prevProps.manageArticleTag.tagAddedSuccess !== this.props.manageArticleTag.tagAddedSuccess &&
			this.props.manageArticleTag.tagAddedSuccess
		) {
			this.props.closeModal();
		}
	}

	public onSubmit(form: IArticleTagManageDomainValue) {
		this.props.createArticleTag(form);
	}

	public closeModal() {
		onCloseModalForm(this.props.dirty, this.props.showModal, this.props.closeModal, this.props.t);
	}

	private mapErrorKeyToMessage(key: string, t: (key: string) => string) {
		switch (key) {
			case 'languageKey':
				return t('Article_ArticleTags_ManageArticleTag_Label_Language');

			case 'value':
				return t('Article_ArticleTags_ManageArticleTag_Label_Name');

			default:
				return key;
		}
	}

	public render() {
		const { pristine, submitting, handleSubmit, t, showHeaderCloseButton, submitFailed, formErrors } = this.props;
		const { isFetching, error, message } = this.props.manageArticleTag;
		const { languageDomainValues } = this.props;

		const errorSummaryProps = {
			formErrors,
			submitFailed,
			error,
			message,
			location,
			mapErrorKeyToMessage: this.mapErrorKeyToMessage,
		};

		let renderLoader = false;
		if (isFetching) {
			renderLoader = true;
		}

		return (
			<Modal
				modalClass="manageTagsModal"
				title={t('Article_ArticleTags_ManageArticleTag_Title')}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={this.closeModal}
			>
				<LoadingOverlayWrapper active={renderLoader} spinner={true} text={t('BSPortal_Common_Loading')}>
					<form onSubmit={handleSubmit(this.onSubmit)}>
						<div className="profileError">
							<ErrorSummary {...errorSummaryProps} />
						</div>
						<Field name="id" component="input" type="hidden" />
						<PortalPageSection usage="admin">
							<div className="row">
								<div className="col-md-12">
									<Field
										name="languageKey"
										component={PortalSelectMenu}
										usage="admin"
										items={languageDomainValues}
										autoFocus={true}
										isRequired={true}
										validate={[required]}
										label={t('Article_ArticleTags_ManageArticleTag_Label_Language')}
										searchable={false}
									/>
								</div>
							</div>

							<div className="row">
								<div className="col-md-12">
									<Field
										name="value"
										component={PortalInputField}
										usage="admin"
										type="text"
										validate={[required, nonWhitespace]}
										label={t('Article_ArticleTags_ManageArticleTag_Label_Name')}
									/>
								</div>
							</div>
						</PortalPageSection>
						<ButtonsSection>
							<div className="row">
								<div className="col-sm-12">
									<Button type="submit" usage="admin" disabled={pristine || submitting}>
										{t('BSPortal_Common_SaveAndClose')}
									</Button>
								</div>
							</div>
						</ButtonsSection>
					</form>
				</LoadingOverlayWrapper>
			</Modal>
		);
	}
}

let ManageArticleTag = reduxForm({
	form: c.FORM_NAME_EDIT_ARTICLE_TAG,
	enableReinitialize: true,
})(EditArticleTagForm);

ManageArticleTag = connect(
	(state: IStore) => {
		return {
			initialValues: state.manageArticleTag.articleTag,
			manageArticleTag: state.manageArticleTag,
			languageDomainValues: state.domainValues.languages,
			formErrors: getFormSyncErrors(c.FORM_NAME_EDIT_ARTICLE_TAG)(state),
		};
	},
	(dispatch) => ({
		createArticleTag: (tag: any) => dispatch(createArticleTag(tag)),
	}),
)(ManageArticleTag);

export { ManageArticleTag };
